import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { ShieldCheck, CreditCard, Truck } from 'lucide-react';
export function Checkout() {
  const {
    items,
    cartTotal,
    clearCart
  } = useCart();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsProcessing(true);
    // Simulate API call
    setTimeout(() => {
      clearCart();
      navigate('/success');
    }, 2000);
  };
  if (items.length === 0) {
    return <div className="p-20 text-center" data-id="element-345">Tu carrito está vacío</div>;
  }
  return <div className="bg-[#f4f4f4] min-h-screen py-12" data-id="element-346">
      <div className="max-w-7xl mx-auto px-4" data-id="element-347">
        <h1 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-348">
          Finalizar Compra
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-349">
          {/* Checkout Form */}
          <div className="lg:col-span-2 space-y-8" data-id="element-350">
            {/* Personal Info */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-351">
              <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-352">
                <span className="w-8 h-8 bg-[#234d99] text-white rounded-full flex items-center justify-center text-sm" data-id="element-353">
                  1
                </span>
                Información Personal
              </h2>
              <form id="checkout-form" onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-354">
                <div className="space-y-2" data-id="element-355">
                  <label className="text-sm font-medium text-gray-700" data-id="element-356">
                    Nombre
                  </label>
                  <input required type="text" className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#234d99] outline-none" data-id="element-357" />
                </div>
                <div className="space-y-2" data-id="element-358">
                  <label className="text-sm font-medium text-gray-700" data-id="element-359">
                    Apellidos
                  </label>
                  <input required type="text" className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#234d99] outline-none" data-id="element-360" />
                </div>
                <div className="space-y-2 md:col-span-2" data-id="element-361">
                  <label className="text-sm font-medium text-gray-700" data-id="element-362">
                    Email
                  </label>
                  <input required type="email" className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#234d99] outline-none" data-id="element-363" />
                </div>
                <div className="space-y-2 md:col-span-2" data-id="element-364">
                  <label className="text-sm font-medium text-gray-700" data-id="element-365">
                    Teléfono
                  </label>
                  <input required type="tel" className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#234d99] outline-none" data-id="element-366" />
                </div>
              </form>
            </div>

            {/* Payment Placeholder */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-367">
              <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-368">
                <span className="w-8 h-8 bg-[#234d99] text-white rounded-full flex items-center justify-center text-sm" data-id="element-369">
                  2
                </span>
                Método de Pago
              </h2>
              <div className="p-4 border-2 border-[#234d99] bg-blue-50 rounded-lg flex items-center justify-between cursor-pointer" data-id="element-370">
                <div className="flex items-center gap-3" data-id="element-371">
                  <CreditCard className="w-6 h-6 text-[#234d99]" data-id="element-372" />
                  <span className="font-medium text-gray-900" data-id="element-373">
                    Tarjeta de Crédito / Débito
                  </span>
                </div>
                <div className="w-4 h-4 rounded-full border-4 border-[#234d99]" data-id="element-374" />
              </div>
              <div className="mt-4 p-4 border border-gray-200 rounded-lg flex items-center justify-between opacity-50 cursor-not-allowed" data-id="element-375">
                <span className="font-medium text-gray-500" data-id="element-376">
                  PayPal (Próximamente)
                </span>
              </div>
            </div>
          </div>

          {/* Order Summary */}
          <div className="lg:col-span-1" data-id="element-377">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 sticky top-24" data-id="element-378">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-379">
                Resumen del Pedido
              </h2>

              <div className="space-y-4 mb-6 max-h-60 overflow-y-auto pr-2" data-id="element-380">
                {items.map(item => <div key={item.id} className="flex gap-3 text-sm" data-id="element-381">
                    <img src={item.imageUrl} alt={item.title} className="w-12 h-12 object-cover rounded bg-gray-100" data-id="element-382" />
                    <div className="flex-1" data-id="element-383">
                      <p className="font-medium text-gray-900 line-clamp-2" data-id="element-384">
                        {item.title}
                      </p>
                      <p className="text-gray-500" data-id="element-385">Cant: {item.quantity}</p>
                    </div>
                    <span className="font-medium" data-id="element-386">
                      €{(item.price * item.quantity).toFixed(2)}
                    </span>
                  </div>)}
              </div>

              <div className="border-t pt-4 space-y-2 text-sm" data-id="element-387">
                <div className="flex justify-between text-gray-600" data-id="element-388">
                  <span data-id="element-389">Subtotal</span>
                  <span data-id="element-390">€{cartTotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-391">
                  <span data-id="element-392">Envío</span>
                  <span className="text-green-600 font-medium" data-id="element-393">Gratis</span>
                </div>
                <div className="flex justify-between text-lg font-bold text-gray-900 pt-2 border-t mt-2" data-id="element-394">
                  <span data-id="element-395">Total</span>
                  <span data-id="element-396">€{cartTotal.toFixed(2)}</span>
                </div>
              </div>

              <button type="submit" form="checkout-form" disabled={isProcessing} className="w-full mt-6 bg-[#234d99] text-white font-bold py-3 rounded-lg hover:bg-[#1a3a75] transition-colors flex items-center justify-center gap-2 disabled:opacity-70" data-id="element-397">
                {isProcessing ? 'Procesando...' : 'Confirmar Pedido'}
                {!isProcessing && <ShieldCheck className="w-5 h-5" data-id="element-398" />}
              </button>

              <div className="mt-4 flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-399">
                <ShieldCheck className="w-4 h-4" data-id="element-400" />
                Pagos procesados de forma segura
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}